import React, { useState, useEffect } from 'react'
import { Box } from '@mui/system'
import { makeStyles } from '@material-ui/core'
import { sliderClasses } from '@mui/base/Slider'
import { Slider } from '@mui/base'

const HMapBubbleSlider = ({
  width,
  name,
  defaultValues,
  onChange,
  disabled
}) => {
  const [value, setValue] = useState([])
  const classes = useStyles({ width })

  const handleChange = (event, newValue) => {
    var minDistance = 5
    const res = newValue.map((val, idx) => {
      // if (idx===0) return 0
      // if (idx===3) return 100
      if (idx === 1) {
        if (val < 10) return 10
        if (val > value[2]) return val - minDistance
        return val
      }
      if (idx === 2) {
        if (val > 100 - minDistance) return 100 - minDistance
        if (val < value[1]) return val + minDistance
        return val
      }

      return val
    })
    setValue([...res])
    !!onChange && onChange({ target: { value: [...res], name } })

    // setValue([...newValue])
    // !!onChange && onChange(newValue)
  }

  const SliderValueLabel = ({ index, children }) => {
    return (
      <span data-index={`${index}`} className="label">{`${children}%`}</span>
    )
  }

  useEffect(() => {
    setValue((!!defaultValues && [...defaultValues]) || [0, 25, 50, 75, 100])
  }, [defaultValues])

  return (
    <Box className={classes.boxi}>
      <Slider
        className={classes.root}
        name={name}
        value={value}
        onChange={handleChange}
        getAriaLabel={() => 'Temperature range'}
        min={0}
        max={100}
        slots={{ valueLabel: SliderValueLabel }}
        disabled={!!disabled}
      />
    </Box>
  )
}

export default React.memo(HMapBubbleSlider)

const useStyles = makeStyles((theme) => ({
  boxi: {
    width: (props) => (props.width ? props.width : '100%'),
    height: '115px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-end',
    padding: '0 0 10px 0'
  },
  root: {
    width: '89%',
    display: 'inline-block',
    position: 'relative',
    cursor: 'pointer',
    'touch-action': 'none',
    '-webkit-tap-highlight-color': 'transparent',
    '&:hover': {
      opacity: 1
    },
    [`&.${sliderClasses.disabled}`]: {
      // 'pointer-events': 'none',
      // cursor: 'default',
      // color: `${theme.palette.mode === 'light' ? grey[300] : grey[600]}`,
      // opacity: 0.5
    },
    [`& .${sliderClasses.rail}`]: {
      display: 'block',
      position: 'absolute',
      width: '100%',
      height: '4px',
      borderRadius: '2px',
      backgroundColor: theme.palette.secondary.main
    },
    [`& .${sliderClasses.track}`]: {
      display: 'block',
      position: 'absolute',
      height: '4px',
      borderRadius: '2px',
      backgroundColor: theme.palette.secondary.main
    },
    [`& .${sliderClasses.thumb}`]: {
      position: 'absolute',
      zIndex: 20,
      marginLeft: '-6px',
      marginTop: '-6px',
      boxSizing: 'border-box',
      outline: 0,
      border: `1px solid ${theme.palette.primary.main}`,
      background: theme.palette.primary.main,
      padding: '0px',
      borderRadius: '50% 50% 50% 0',
      '&[data-index="0"]': {
        width: '25px',
        height: '25px',
        transform: 'translate(-7px, -20px) rotate(-45deg)'
      },
      '&[data-index="1"]': {
        width: '35px',
        height: '35px',
        transform: 'translate(-24px, -33px) rotate(-45deg)'
      },
      '&[data-index="2"]': {
        width: '45px',
        height: '45px',
        transform: 'translate(-24px, -44px) rotate(-45deg)'
      },
      '&[data-index="3"]': {
        width: '55px',
        height: '55px',
        transform: 'translate(-24px, -56px) rotate(-45deg)'
      },
      '&[data-index="4"]': {
        width: '65px',
        height: '65px',
        transform: 'translate(-29px, -69px) rotate(-45deg)'
      },
      '& .label': {
        position: 'absolute',
        zIndex: 30,
        background: 'white',
        border: `0.7px solid ${theme.palette.tertiary.accent}`,
        borderRadius: '5px',
        padding: '3px',
        ...theme.typography.p,
        color: theme.palette.tertiary.accent,
        '&[data-index="0"]': {
          border: `0.7px solid ${theme.palette.secondary.main}`,
          color: theme.palette.secondary.main,
          transform: 'translate(19px, -21px) rotate(45deg)'
        },
        '&[data-index="1"]': {
          transform: 'translate(24px, -19px) rotate(45deg)'
        },
        '&[data-index="2"]': {
          transform: 'translate(32px, -18px) rotate(45deg)'
        },
        '&[data-index="3"]': {
          transform: 'translate(40px, -18px) rotate(45deg)'
        },
        '&[data-index="4"]': {
          transform: 'translate(46px, -16px) rotate(45deg)'
        }
      }
    },
    [`& .${sliderClasses.mark}`]: {
      position: 'absolute',
      width: '4px',
      height: '4px',
      borderRadius: '2px',
      backgroundColor: 'currentColor',
      top: '50%',
      opacity: '0.7',
      transform: 'translateX(-50%)'
    },

    [`& .${sliderClasses.markActive}`]: {
      backgroundColor: '#fff'
    }
  }
}))
